"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouter = void 0;
var react_1 = require("react");
exports.useRouter = function (router) {
    var _a = react_1.useState(router.route), route = _a[0], setRoute = _a[1];
    var _b = react_1.useState(router.matchedRoute), matchedRoute = _b[0], setMatchedRoute = _b[1];
    var _c = react_1.useState(router.params), params = _c[0], setParams = _c[1];
    react_1.useEffect(function () {
        var changeListener = function (_a) {
            var route = _a.route, matchedRoute = _a.matchedRoute, params = _a.params;
            setRoute(route);
            setMatchedRoute(matchedRoute);
            setParams(params);
        };
        router.addChangeListener(changeListener);
        return function () { return router.removeChangeListener(changeListener); };
    }, []);
    return { route: route, matchedRoute: matchedRoute, params: params };
};
